import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import { DeleteWithConfirmButton, SaveButton, Toolbar } from 'react-admin';
import { InquiryTypeRecord } from '../interfaces/inquiry-type-record.interface';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const InquiryTypeEditToolbar = (props: {
  record?: InquiryTypeRecord;
}) => {
  const { record } = props;
  return (
    <Toolbar {...props} classes={useStyles()}>
      <SaveButton />
      {record && record.id && (
        <DeleteWithConfirmButton
          undoable={false}
          redirect={`/company/${record?.companyId ?? ''}`}
          confirmTitle="messages.inquiryType.deleteConfirmTitle"
          confirmContent="messages.inquiryType.deleteConfirmContent"
        />
      )}
    </Toolbar>
  );
};
